module.exports = function(app) {
	app.filter('relationship', ['employee', 'coverageBuddy', function(employee, coverageBuddy) {
		var relationshipMap =
			employee.metadata && employee.metadata.relationshipMap || coverageBuddy.relationshipMap;

		return function(code) {
			return relationshipMap[code] || 'NOT FOUND';
		};
	}]);

	app.filter('otherInsuranceRelationship', function() {
		return function(code) {
			switch (code) {
				case '1': return 'Self';
				case '2': return 'Spouse';
				case '3': return 'Child';
				case '4': return 'Handicapped Dependent';
				case '5': return 'Other/Domestic Partner';
				default: return 'Unknown';
			}
		};
	});
};


